// The query string of `params`, as `new URLSearchParams(params)` makes it,
// except that a list is sent as its key repeated for each value
// (categories=11&categories=12) and not as one value (categories=11,12). That
// is how the API takes a filter that accepts several values: `categories=11,12`
// is refused as "not a valid value".
export const toQueryString = params => {
  const query = new URLSearchParams()
  for (const [key, value] of Object.entries(params || {})) {
    for (const item of Array.isArray(value) ? value : [value]) {
      query.append(key, item)
    }
  }
  return query.toString()
}
